import React from "react";

const ScreenHeading = (props) => {
  return (
    <div className="container p-6">
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <h1 className="title is-1">{props.title}</h1>
          </div>
        </div>
        <div className="level-right">{props.children}</div>
      </div>
    </div>
  );
};

export default ScreenHeading;
